export default {
    stores: {
        document: '№ документа',
        store: 'Склад',
        stores: 'Склады',
        storesFrom:'Со склада',
        storesTo:'На склад',
        storeType: 'Тип склада',
        operation: 'Операция',
        cashbox:'Касса',
        operations: {
            Add: 'Добавить склад',
            AddProduct: 'Добавить товар',
            operation: 'Складские операции',
            statusPayment: 'Статус оплаты',
            PaymentFinished: 'Оплачен',
            // worker: 'Продавший сотрудник',
            counterparties: 'Контрагент',
            sale: 'Продажа',
            in: 'Приход',
            off: 'Списание',
            types: 'Типы операций',
            period: 'Период',
            addFromList:'Добавить из списка',
            move:'Переместить'
        },
        actions:{
            update:'Сохранить складскую операцию',
            saveCreate:'Сохранить и создать складскую операцию',
            savePay: 'Сохранить и перейти к оплате'
        }

    },

    documents: {
        search: 'Поиск по номеру документа',
    },
    products: {
        sale: 'Продажа товара',
        writeOff: 'Списание товара',
        arrival: 'Приход товара',
        product: 'Товар',
        products: 'Товары',
        search: 'Поиск товара по наименованию или коду',
        massEdit: 'Массовое редактирование',
        archiveProducts: 'Архив товаров',
        operation: 'Операции с товарами',
        move: 'Перемещение товаров',
        category: {
            selectCategory:'Укажите категорию',
            category: 'Категории товаров',
            addCategory: 'Добавить категорию',
            parentCategory: 'Родительская категория',
            article: 'Артикул',
        },
    },
};
